import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/play/play/apps/play-portal/src/app/_components/analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/play/play/apps/play-portal/src/app/games/(details)/[uid]/game-details.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscribedLayout"] */ "/home/runner/work/play/play/apps/play-portal/src/app/games/(details)/[uid]/SubscribedLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Layout"] */ "/home/runner/work/play/play/apps/play-portal/src/components/layout/Layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/play/play/node_modules/@mui/icons-material/esm/Telegram.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/play/play/node_modules/@mui/icons-material/esm/X.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/play/play/node_modules/@mui/material/SvgIcon/SvgIcon.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicNextImage"] */ "/home/runner/work/play/play/node_modules/@prismicio/next/dist/PrismicNextImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicNextLink"] */ "/home/runner/work/play/play/node_modules/@prismicio/next/dist/PrismicNextLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicPreviewClient"] */ "/home/runner/work/play/play/node_modules/@prismicio/next/dist/PrismicPreviewClient.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/play/play/node_modules/next/dist/client/script.js");
